import Axios from 'axios'
import store from '../store'
import strings from '@/strings'
import utils from '@/utils/utils.js'

const report = {
  getClientId() {
    return store.getters["Client/clientId"]
  },
  getRecipientsEmail() {
    return Axios.get(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/meals/recipients`)
  },
  saveRecipientsEmail(emails) {
    return Axios.put(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/meals/recipients`, emails)
  },
  getDashboardDeskToken() {
    return Axios.get(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/reports/dashboards/desks`)
  },
  getDashboardComfortReportToken() {
    return Axios.get(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/reports/dashboards/comfort`)
  },
  getDashboardMonitoringToken() {
    return Axios.get(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/reports/dashboards/monitoring`)
  },
  getDashboardCharteredToken() {
    return Axios.get(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/reports/dashboards/chartered`)
  },
  getDashboardParkingToken() {
    return Axios.get(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/reports/dashboards/parking`)
  },
  getDashboardRestaurantToken() {
    return Axios.get(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/reports/dashboards/restaurant`)
  },
  getDeskReport(filters) {
    const config = utils.generateQueryString(filters, false)
    return Axios.get(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/reports/bookings`, config)
  },
  getCharteredReport(filters) {
    const config = utils.generateQueryString(filters, false)
    return Axios.get(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/reports/chartered-bookings`, config)
  },
  getParkingReport(filters) {
    const config = utils.generateQueryString(filters, false)
    return Axios.get(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/reports/parking-bookings`, config)
  },
  getRestaurantReport(filters) {
    const config = utils.generateQueryString(filters, false)
    return Axios.get(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/reports/restaurant-bookings`, config)
  },
  getLockerReport(filters) {
    const config = utils.generateQueryString(filters, false)
    return Axios.get(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/reports/locker-bookings`, config)
  },
  getRestrictionReport(filters) {
    const config = utils.generateQueryString(filters, false)
    return Axios.get(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/reports/restrictions`, config)
  },
  getFilterDeskReport () {
    return Axios.get(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/reports/bookings/filters`)
  },
  getFilterCharteredReport () {
    return Axios.get(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/reports/chartered-bookings/filters`)
  },
  getFilterParkingReport () {
    return Axios.get(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/reports/parking-bookings/filters`)
  },
  getFilterRestaurantReport () {
    return Axios.get(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/reports/restaurant-bookings/filters`)
  },
  getFilterLockerReport () {
    return Axios.get(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/reports/locker-bookings/filters`)
  },
  getFilterRestrictionReport () {
    return Axios.get(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/reports/restrictions/filters`)
  },
  getAnotherPersonAndGuestReport(filters) {
    const config = utils.generateQueryString(filters, false)
    return Axios.get(`api/${strings.apiVersion.admin}/clients/${this.getClientId()}/reports/bookings/another-person-guest`, config)
  },
  getReportFile(filters) {
    const config = utils.generateQueryString(filters, true)
    return Axios.get(`/api/${strings.apiVersion.admin}/clients/${this.getClientId()}/reports/bookings/file`, config)
  },
  getDeskReportFileForAnotherPesron(filters){
    const config = utils.generateQueryString(filters, true)
    return Axios.get(`/api/${strings.apiVersion.admin}/clients/${this.getClientId()}/reports/bookings/another-person-guest/file`, config)
  },
  getParkingReportFile(filters){
    const config = utils.generateQueryString(filters, true)
    return Axios.get(`/api/${strings.apiVersion.admin}/clients/${this.getClientId()}/reports/parking-bookings/file`, config)
  },
  getLockerReportFile(filters) {
    const config = utils.generateQueryString(filters, true)
    return Axios.get(`/api/${strings.apiVersion.admin}/clients/${this.getClientId()}/reports/locker-bookings/file`, config)
  },
  getCharteredBusReportFile(filters) {
    const config = utils.generateQueryString(filters, true)
    return Axios.get(`/api/${strings.apiVersion.admin}/clients/${this.getClientId()}/reports/chartered-bookings/file`, config)
  },
  getRestaurantReportFile(filters) {
    const config = utils.generateQueryString(filters, true)
    return Axios.get(`/api/${strings.apiVersion.admin}/clients/${this.getClientId()}/reports/restaurant-bookings/file`, config)
  },
  getRestrictionReportFile(filters) {
    const config = utils.generateQueryString(filters, true)
    return Axios.get(`/api/${strings.apiVersion.admin}/clients/${this.getClientId()}/reports/restrictions/file`, config)
  }
}

export default report
